import SiteHeader from "@/pages/home/components/SiteHeader";
import HeroSection from "@/pages/home/components/HeroSection";
import FeedSection from "@/pages/home/components/FeedSection";
import ResourceSection from "@/pages/home/components/ResourceSection";
import ChapterSection from "@/pages/home/components/ChapterSection";
import AudiobookSection from "@/pages/home/components/AudiobookSection";
import CollectionSection from "@/pages/home/components/CollectionSection";
import RankingSection from "@/pages/home/components/RankingSection";
import NotesSection from "@/pages/home/components/NotesSection";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteHeader />
      <main>
        <HeroSection />
        <FeedSection />
        <ResourceSection />
        <ChapterSection />
        <AudiobookSection />
        <CollectionSection />
        <RankingSection />
        <NotesSection />
      </main>
      <SiteFooter />
    </div>
  );
}